var Education = "교육";
var Enterprise = "Enterprise";
var CompanyType = {
	"Company type": "회사 유형",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "정부 - 연방",
	"Government - State & local": "정부 - 중앙 및 지방",
	"Non-profit": "비영리",
	"Self employed": "자영업",
	"Small-medium business": "중소기업",
	"Start-up": "스타트업",
	"Not applicable": "해당 사항 없음"
};

export { Education, Enterprise, CompanyType as default };
